import { render, staticRenderFns } from "./cargos.vue?vue&type=template&id=4fd1ea34&"
import script from "./cargos.vue?vue&type=script&lang=js&"
export * from "./cargos.vue?vue&type=script&lang=js&"
import style0 from "./cargos.vue?vue&type=style&index=0&id=4fd1ea34&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports